import script from "./ChildAuth.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChildAuth.vue?vue&type=script&lang=ts&setup=true"

import "./ChildAuth.vue?vue&type=style&index=0&id=577bd86a&lang=css"

const __exports__ = script;

export default __exports__